import React, { useEffect, useState } from "react";
import Styles from "./Style.module.css";
import { useHistory } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

const App = (props) => {
  const history = useHistory();
  const [cancellationConfirmation, setCancellationConfirmation] =
    useState(null);

  useEffect(() => {
    if (cancellationConfirmation && cancellationConfirmation === "cancel") {
      if (window.showNotification) {
        window.showNotification("SUCCESS", "Thank you for staying with us");
      }
      history.push("/");
    } else if (
      cancellationConfirmation &&
      cancellationConfirmation === "confirm"
    ) {
      history.push("/cancellation-request/confirm");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancellationConfirmation]);

  return (
    <div className={Styles.pageWrapper}>
      <Card className={Styles.card} elevation={6}>
        <div className={Styles.imageWrapper}>
          <img
            src="https://s3.us-east-1.amazonaws.com/pypepro/user/1/S5QX7Pdl1VB46EquVO7OKp76oLAJHTRD5cTdxN1d.gif"
            alt="Sad moment"
            className={Styles.image}
            style={{ height: "260px" }}
          />
        </div>

        <CardHeader
          title={
            <div className={Styles.title}>We are sorry to see you go! 😢</div>
          }
        />
        <Divider />
        <CardContent>
          <div className={Styles.warning}>
            <strong>Important:</strong> Deleting your account will permanently
            erase all your data.<br/> This action cannot be undone.
          </div>

          <Box className={Styles.radioSection}>
            <div className={Styles.selectOptionLabel}>
              Please choose an option:
            </div>

            <RadioGroup
              value={cancellationConfirmation}
              onChange={(e) => setCancellationConfirmation(e.target.value)}
            >
              <FormControlLabel
                value="confirm"
                control={<Radio color="primary" />}
                label="Yes, I understand and want to delete my account"
              />
              <FormControlLabel
                value="cancel"
                control={<Radio color="primary" />}
                label="No, I’ve changed my mind and want to stay"
              />
            </RadioGroup>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default App;
